export default __webpack_public_path__ + "static/media/75.8956c535.png";